export default __webpack_public_path__ + "static/media/payrollprocessing.5a07b108.svg";